var header_menu_default = (() => {
    if (customElements.get("header-menu")) return;
    const TOGGLE_DELAY = 100;
    const CLOSE_DELAY = 100;
    const CLICK_GUARD_MS = 500;
    customElements.define("header-menu", class HeaderMenu extends HTMLElement {
        constructor() {
            super();
            this.details = this.querySelector("details.header--level1");
            this.summary = this.details?.querySelector("summary.header--level1");
            this.megaMenu = this.querySelector('[id^="MegaMenu-Content-"]');
            this.isDesktop = window.matchMedia("(min-width: 1025px)");
            this.openTimer = null;
            this.closeTimer = null;
            this.desktopListenersAdded = false;
            this.openSource = null;
            this.openedAt = 0;
            this.close = this.close.bind(this);
            this.onSummaryEnter = this.onSummaryEnter.bind(this);
            this.onSummaryLeave = this.onSummaryLeave.bind(this);
            this.onPanelEnter = this.onPanelEnter.bind(this);
            this.onPanelLeave = this.onPanelLeave.bind(this);
            this.onToggle = this.onToggle.bind(this);
            this.onSummaryClick = this.onSummaryClick.bind(this);
        }
        connectedCallback() {
            this.handleMediaChange(this.isDesktop);
            this.isDesktop.addEventListener("change", this.handleMediaChange);
        }
        disconnectedCallback() {
            this.isDesktop.removeEventListener("change", this.handleMediaChange);
            this.removeDesktopListeners();
        }
        get nav() {
            return this.closest("nav");
        }
        get megaBackground() {
            return this.nav?.querySelector(".header-mega__background");
        }
        handleMediaChange=e => {
            if (e.matches) this.addDesktopListeners(); else {
                this.removeDesktopListeners();
                this.close();
            }
        };
        onToggle=e => {
            const isOpen = e.newState === "open";
            if (isOpen) this.openedAt = performance.now();
            if (this.megaMenu) {
                this.megaMenu.setAttribute("aria-hidden", !isOpen);
                this.megaMenu.setAttribute("tabindex", isOpen ? "0" : "-1");
            }
            if (!isOpen) {
                if (!this.nav?.querySelector("header-menu details.header--level1[open]")) this.resetMegaBackground();
            } else this.sizeMegaBackground();
        };
        onSummaryEnter() {
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => {
                if (this.details?.hasAttribute("open")) return;
                this.closeSiblingMenus();
                this.openSource = "hover";
                this.summary?.click();
            }, TOGGLE_DELAY);
        }
        onSummaryLeave() {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.close(), CLOSE_DELAY);
        }
        onPanelEnter() {
            clearTimeout(this.closeTimer);
        }
        onPanelLeave() {
            this.closeTimer = setTimeout(() => this.close(), CLOSE_DELAY);
        }
        onSummaryClick(e) {
            if (e.detail < 1) return;
            const isOpen = this.details?.hasAttribute("open");
            const msSinceOpen = this.openedAt ? performance.now() - this.openedAt : null;
            if (isOpen && this.openSource === "hover" && msSinceOpen !== null && msSinceOpen < CLICK_GUARD_MS) e.preventDefault();
            this.openSource = "click";
        }
        closeSiblingMenus() {
            this.nav?.querySelectorAll("header-menu details.header--level1[open]").forEach(detail => {
                if (detail !== this.details) detail.removeAttribute("open");
            });
        }
        sizeMegaBackground() {
            const background = this.megaBackground;
            const panel = this.megaMenu;
            const nav = this.nav;
            if (!background || !panel) return;
            requestAnimationFrame(() => {
                const height = panel.offsetHeight;
                background.style.height = `${height}px`;
                nav?.style.setProperty("--mega-bg-height", `${height}px`);
            });
        }
        resetMegaBackground() {
            const background = this.megaBackground;
            const nav = this.nav;
            if (background) background.style.height = "0px";
            nav?.style.setProperty("--mega-bg-height", "0px");
        }
        addDesktopListeners() {
            if (this.desktopListenersAdded) return;
            this.details?.addEventListener("toggle", this.onToggle);
            this.summary?.addEventListener("mouseenter", this.onSummaryEnter, {
                passive: true
            });
            this.summary?.addEventListener("mouseleave", this.onSummaryLeave, {
                passive: true
            });
            this.summary?.addEventListener("click", this.onSummaryClick);
            this.megaMenu?.addEventListener("mouseenter", this.onPanelEnter, {
                passive: true
            });
            this.megaMenu?.addEventListener("mouseleave", this.onPanelLeave, {
                passive: true
            });
            this.desktopListenersAdded = true;
        }
        removeDesktopListeners() {
            if (!this.desktopListenersAdded) return;
            this.details?.removeEventListener("toggle", this.onToggle);
            this.summary?.removeEventListener("mouseenter", this.onSummaryEnter);
            this.summary?.removeEventListener("mouseleave", this.onSummaryLeave);
            this.summary?.removeEventListener("click", this.onSummaryClick);
            this.megaMenu?.removeEventListener("mouseenter", this.onPanelEnter);
            this.megaMenu?.removeEventListener("mouseleave", this.onPanelLeave);
            clearTimeout(this.openTimer);
            clearTimeout(this.closeTimer);
            this.desktopListenersAdded = false;
        }
        close() {
            if (this.megaMenu && this.megaMenu.contains(document.activeElement)) this.summary?.focus();
            if (this.details?.hasAttribute("open")) this.details.removeAttribute("open");
        }
    });
})();